// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1099":"e7f491fb","4774":"c1383c32","8847":"92e7ea31"}[chunkId] + ".css";
};